var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"announcement-view-panel"}},[_c('j-heading',{attrs:{"heading":"Comments"}}),_c('CommentManager',{attrs:{"source":_vm.announcement}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }